/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-25 13:42:11
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "antd/dist/antd.css";
import Top from "../../../components/common/Top";
import Footer from "../../../components/common/Footer";
import FreeTrial from "../../../components/FreeTrial";
import Banner from "../common/Banner";
import { Layout } from "antd";
import actionWays from "../../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../../inphone.scss";
import Work from "./Work";
import Industry from "./Industry";
import Collaborate from "./Collaborate";
import Case from "./Case";
import Carousel from "./Carousel";
import { adaptation } from "../../../utils/adaptation";
import "../common/index.scss";
const { Content } = Layout;
class Guaranteed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  }
  render() {
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* banner图 start*/}
          <Banner active={0} />
          {/* banner图 end*/}
          {/* 锚点 start*/}
          {/* <AnchorPoint anchorPointList={anchorPointList} /> */}
          {/* 锚点 end*/}
          {/* 档案工作面临的问题与挑战 start*/}
          <Work/>
          {/* 档案工作面临的问题与挑战 end*/}
          {/* 档案行业数字化转型 start*/}
          <Industry/>
          {/* 档案行业数字化转型 end*/}
          {/* 内外协同 start*/}
          <Collaborate/>
          {/* 内外协同 end*/}
          {/* 为什么选择我们 start*/}
          <Carousel/>
          {/* 为什么选择我们 end*/}
          {/* 让不同行业找到更合适自己的协同方式 start*/}
          <Case/>
          {/* 在线体验 start*/}
          <FreeTrial />
          {/* 在线体验 end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Guaranteed));
